export interface UrlConfig {
  API_SUBDOMAIN: string; // e.g. 'api' | 'api-staging', passed in through config
  API_URL: string; // derived
  API_OVERRIDE?: string; // e.g. localhost:3000, for testing locally
}

export function getEnvFromHostname(): 'production' | 'staging' | 'local' {
  if (typeof window === 'undefined') {
    return 'local';
  }
  const { hostname } = window.location;
  if (hostname === 'localhost' || hostname === '192.168.99.100') {
    return 'local';
  }
  if (/-staging\./.test(hostname) || /\.diff-preview\./.test(hostname)) {
    return 'staging';
  }
  return 'production';
}

export function createConfigWithDerivedApiUrl<T extends UrlConfig>(partialConfig: Omit<T, 'API_URL'>) {
  return {
    ...partialConfig,
    API_URL: buildAPIURL(partialConfig.API_SUBDOMAIN, partialConfig.API_OVERRIDE),
  };
}

export function buildAPIURL(subdomain: string, urlOverride?: string): string {
  if (urlOverride) {
    return urlOverride;
  }
  const { hostname } = window.location;
  if (hostname === 'localhost' || hostname === '192.168.99.100' || /\.diff-preview\./.test(hostname)) {
    return `https://${subdomain}.csschina.com`;
  }
  // replace first subdomain with prefix
  return `https://${hostname.replace(/^[^.]*/, subdomain)}`;
}

export * from './translateAppUrls';
